import { ITreatmentOfChronicAcromegallyPegvisomant } from './TreatmentOfChronicAcromegallyPegvisomant.types';

export const initialTreatmentOfChronicAcromegallyPegvisomant : ITreatmentOfChronicAcromegallyPegvisomant= {
  frequency: "",
  dose: "",
  dateStart: null,
  dateEnd: null,
  dateEndIsActive: false
}